import { selectInData } from '@missionlabs/api'
import { Destination, DestinationTypes } from '@missionlabs/types'

export const selectDestinationsByTypes = (allowedTypes: DestinationTypes[]) =>
    selectInData<Destination[], Destination[]>(
        data => data?.filter(({ type }) => allowedTypes.includes(type)) || []
    )
